@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.body {
  margin-left: calc(var(--collab-item-avatar-size) + var(--collab-item-avatar-gap));
  @include md-sohne;
  color: var(--dark-80);
  overflow-wrap: break-word;

  --prose-input-font-size: 16px;

  [data-autopilot-system-redesign='on'] & {
    --prose-input-font-size: 14px;
  }
}
